import React from 'react';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
import { DOCUMENTO_DESIGN as D } from '../EditorDocumento.design';

// Topbar do editor de proposta: voltar, nome do documento (editável — no design
// livre não existe outro campo para ele) e, à direita, no máximo prévia,
// compartilhar e a ação primária. Modelo e formato do editor moram no painel
// lateral, porque são escolhas iniciais, não ações recorrentes.
export default function EditorTopBar({ isEditing, titulo, onChangeTitulo, subtitulo, saving, onSave, saveLabel, disabled, canShare, onShare, previewMode, onTogglePreview, onBack }) {
  const navigate = useNavigate();

  return (
    <header className={D.topbar}>
      <div className={D.topbarLeft}>
        <button
          type="button"
          className={D.back}
          onClick={onBack || (() => navigate('/dashboard/propostas'))}
          title="Voltar"
          aria-label="Voltar"
        >
          <Iconify icon="eva:arrow-back-outline" width={20} />
        </button>
        <div className="min-w-0 flex-1">
          {onChangeTitulo ? (
            <input
              value={titulo || ''}
              onChange={e => onChangeTitulo(e.target.value)}
              placeholder="Nome da proposta"
              aria-label="Nome da proposta"
              className={D.titleInput}
            />
          ) : (
            <h1 className={D.title}>{titulo || (isEditing ? 'Editar proposta' : 'Nova proposta')}</h1>
          )}
          {subtitulo && <p className={D.subtitle}>{subtitulo}</p>}
        </div>
      </div>

      <div className={D.topbarRight}>
        {onTogglePreview && (
          <button
            type="button"
            className={`${D.btn} ${previewMode ? D.btnSoft : D.btnGhost}`}
            onClick={onTogglePreview}
            aria-pressed={Boolean(previewMode)}
          >
            <Iconify icon={previewMode ? 'mdi:eye-off-outline' : 'mdi:eye-outline'} width={16} />
            {previewMode ? 'Fechar prévia' : 'Pré-visualizar'}
          </button>
        )}

        {canShare && (
          <button type="button" className={`${D.btn} ${D.btnGhost}`} onClick={onShare}>
            <Iconify icon="mdi:share-variant-outline" width={16} />
            Compartilhar
          </button>
        )}

        {!disabled && (
          <button type="button" className={`${D.btn} ${D.btnPrimary}`} onClick={onSave} disabled={saving}>
            {saving && <Iconify icon="mdi:loading" className="animate-spin" width={16} />}
            {saveLabel || (isEditing ? 'Salvar alterações' : 'Criar proposta')}
          </button>
        )}
      </div>
    </header>
  );
}
